export default function () {
    $(function() {
        $('.gamper4-item-triad-element .item-row input').on('change', function () {
            const $triadElement = $(this).parents('.gamper4-item-triad-element');
            // Validate the current traid
            validateTriad($triadElement);
            // Find previous triads, that were not filled or incorrectly
            findIncorrectTriads($triadElement);
        });
    });
}

/**
 * Validates the given triad element, if the input is valid.
 *
 * @param {Object} $triadElement
 */
function validateTriad($triadElement) {
    const triadElementId = $triadElement.data('survey-element-id');
    // Reset all item errors
    $triadElement.find('.item-row').each(function () {
        $(this).removeClass('has-error');
    });
    // Check if there are more then 2 items selected for column "+".
    const $selectedPlusItems = $triadElement.find('.item-row input[value=1]:checked');
    if ($selectedPlusItems.length > 2) {
        showError($selectedPlusItems, '#error-max-plus-' + triadElementId);
    } else {
        if ($selectedPlusItems.length > 0) {
            // Make sure to hide error message about not selecting the minimum number (1) of items for column "+".
            $('#error-min-plus-' + triadElementId).hide();
        }
        $('#error-max-plus-' + triadElementId).hide();
    }
    // Check if there are more then 2 items selected for column "-".
    const $selectedMinusItems = $triadElement.find('.item-row input[value=-1]:checked');
    if ($selectedMinusItems.length > 2) {
        showError($selectedMinusItems, '#error-max-minus-' + triadElementId);
    } else {
        $('#error-max-minus-' + triadElementId).hide();
    }
    // Show error if all items of the triad are set back to '0' (question mark)
    if (($selectedPlusItems.length === 0) && ($selectedMinusItems.length === 0) && $triadElement.data('is-triad-validated')) {
        const $allItems = $triadElement.find('.item-row input');
        showError($allItems, '#error-min-plus-' + triadElementId);
    }
    $triadElement.data('is-triad-validated', true);
}

/**
 * Find triads that are above the current one, that are not filled in correctly
 *
 * @param {Object} $currentTraidElement
 */
function findIncorrectTriads($currentTraidElement) {
    const currentTraidElementID = $currentTraidElement.data('survey-element-id');
    // Get all triads
    $('.gamper4-item-triad-element').each(function () {
        const thisTriadElementID = $(this).data('survey-element-id');
        if ((thisTriadElementID < currentTraidElementID)) {
            const $positiveItems = $('.item-row input[value=1]:checked', $(this));
            const $unchangedItems = $('.item-row input[value=0]:checked', $(this));
            // No positive choice made or not choice made at all
            if ($positiveItems.length === 0 || (!$(this).data('is-triad-validated') && $unchangedItems.length === 3)) {
                const $allItems = $('.item-row input', $(this));
                showError($allItems, '#error-min-plus-' + thisTriadElementID);
                $(this).data('is-triad-validated', true);
            }
        }
    });
}

/**
 * Mark element red and show error message
 *
 * @param {Object} $errorItems
 * @param {String} itemsetErrorID
 */
function showError($errorItems, itemsetErrorID) {
    $errorItems.each(function () {
        $(this).parents('.item-row').addClass('has-error');
    });
    $(itemsetErrorID).show();
}